import React from 'react';
import logo from './res/IMG_1293.jpg';

import ReactGA from 'react-ga';
import Link from "./Link/Link"
import CollapsableSection from "./CollapsableSection/CollapsableSection"
import Resume from "./Resume"
import './App.css';
import Home from "./Home"
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

ReactGA.initialize('UA-127647347-3', {
  debug: false
});

// export NODE_OPTIONS=--openssl-legacy-provider


ReactGA.pageview(window.location.pathname + window.location.search);

class App extends React.Component {

  constructor(props) {
    super(props)
    
  }

  onClick(event) {
    var text = event.target.innerText || event.target.textContent;
    // console.log("Clicked the link", text, "logging event in Google Analytics :) ")
    ReactGA.event({
      category: 'User',
      action: text
    });
  }

  onClickPaper(event, paperName) {
    ReactGA.event({
      category: 'User',
      action: paperName
    });
  }

  render() {
    return (
      <Router>
        <div className="App">
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            
            <Route path="/resume">
              <Resume />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
